/** App semver from `package.json`, injected at build time as `VITE_APP_VERSION`. */

/** @param {Record<string, string | undefined> | null | undefined} [env] */
export function resolveAppVersionFromEnv(env) {
  var e = env || (typeof import.meta !== "undefined" && import.meta.env ? import.meta.env : {});
  var explicit = e.VITE_APP_VERSION != null ? String(e.VITE_APP_VERSION).trim() : "";
  return explicit || "0.0.0";
}

export function getAppVersion() {
  return resolveAppVersionFromEnv();
}

export function formatAppVersionLabel(version) {
  var v = version != null ? String(version).trim() : "";
  if (!v) return "v0.0.0";
  return v.charAt(0) === "v" ? v : "v" + v;
}
